// extracted by mini-css-extract-plugin
export default {"samplesModal":"samplesModal__3JUI4"};